import { create } from "zustand";

interface PricingPageStore {
  displayPricingModal: boolean;
  setDisplayPricingModal: (toggleValue: boolean) => void;
}

export const usePricingPageStore = create<PricingPageStore>((set) => ({
  displayPricingModal: false,
  setDisplayPricingModal: (toggleValue: boolean) => {
    set({ displayPricingModal: toggleValue });
  },
}));
